import { color, rem, resetCss } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  resetCss,
  css`
    :host {
      background: ${color('white')};
      box-sizing: border-box;
      display: flex;
    }

    :where(.container) {
      align-content: center;
      align-items: center;
      cursor: pointer;
      display: flex;
      gap: ${rem(20)};
      inline-size: 100%;
      padding: ${rem(12)};
      user-select: none;
    }

    :where(.check) {
      background-color: ${color('primary', 500)};
      border-radius: 50%;
      color: ${color('white')};
      display: flex;
      margin-inline-start: auto;
      padding: ${rem(4)};
    }

    :host(:hover) {
      background-color: ${color('grey', 100)};
    }

    :host(:focus) {
      background-color: ${color('grey', 100)};
    }

    ::slotted(img) {
      block-size: ${rem(55)};
      inline-size: ${rem(55)};
      object-fit: contain;
    }

    ::slotted(img:not([src*='http'])) {
      visibility: hidden;
    }

    :host(.hidden) {
      display: none;
    }

    :host([disabled]) {
      background: ${color('white')};
      color: ${color('neutral', 400)};

      div {
        cursor: not-allowed;
      }
    }

    :host([disabled]) ::slotted(img) {
      filter: grayscale(100%);
      opacity: 0.5;
    }
  `,
];
